module.exports = __webpack_public_path__ + "static/media/towel2x.629fdc2e.png";